import DOMPurify from "dompurify";

/**
 * Strict allow-list sanitization for email bodies fetched from Lemlist.
 * Strips images (their tracking pixels in particular), scripts, iframes,
 * forms, and any inline event handlers via DOMPurify defaults. The
 * remaining tag/attribute set covers the formatting Lemlist actually
 * emits in campaign templates and reply text.
 */
export function sanitizeEmailHtml(html: string): string {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [
      "div",
      "p",
      "br",
      "strong",
      "b",
      "em",
      "i",
      "u",
      "a",
      "ul",
      "ol",
      "li",
      "span",
      "h1",
      "h2",
      "h3",
      "h4",
      "blockquote",
      "pre",
      "code",
    ],
    ALLOWED_ATTR: ["href", "target", "rel", "style", "class"],
    FORBID_TAGS: ["img", "script", "iframe", "form", "object", "embed"],
    // Force every link to open in a new tab and shed referrer info — the
    // email body could link anywhere, including the prospect's domain.
    ADD_ATTR: ["target"],
  });
}
